import * as React from 'react';
import {
    DefaultButton,
    Dropdown,
    IDropdownOption,
    MessageBar,
    MessageBarType,
    Panel,
    PanelType,
    PrimaryButton,
    Stack,
    TextField,
} from '@fluentui/react';
import { TASK_TYPES } from '../../shared';

interface DuplicateDefinitionPanelProps {
    isOpen: boolean;
    serviceOptions: IDropdownOption[];
    duplicateTargetServiceId?: number;
    duplicateTargetName: string;
    duplicateTaskType: number;
    duplicateSubmitting: boolean;
    duplicateError: string | null;
    onDismiss: () => void;
    onDuplicate: () => void;
    onTargetServiceIdChange: (serviceId?: number) => void;
    onTargetNameChange: (name: string) => void;
    onTargetTaskTypeChange: (taskType: number) => void;
}

export function DuplicateDefinitionPanel(props: DuplicateDefinitionPanelProps) {
    const {
        isOpen,
        serviceOptions,
        duplicateTargetServiceId,
        duplicateTargetName,
        duplicateTaskType,
        duplicateSubmitting,
        duplicateError,
        onDismiss,
        onDuplicate,
        onTargetServiceIdChange,
        onTargetNameChange,
        onTargetTaskTypeChange,
    } = props;

    return (
        <Panel
            isOpen={isOpen}
            onDismiss={onDismiss}
            type={PanelType.smallFixedFar}
            headerText="Duplicate job definition"
        >
            <Stack tokens={{ childrenGap: 12 }}>
                {duplicateError && (
                    <MessageBar messageBarType={MessageBarType.error}>{duplicateError}</MessageBar>
                )}
                <Dropdown
                    label="Target service"
                    options={serviceOptions}
                    selectedKey={duplicateTargetServiceId}
                    onChange={(_, option) => onTargetServiceIdChange(option?.key ? Number(option.key) : undefined)}
                />
                <TextField
                    label="Target name"
                    value={duplicateTargetName}
                    onChange={(_, value) => onTargetNameChange(value ?? '')}
                />
                <Dropdown
                    label="Target task type"
                    options={TASK_TYPES}
                    selectedKey={duplicateTaskType}
                    onChange={(_, option) => onTargetTaskTypeChange(Number(option?.key ?? 0))}
                />
                <Stack horizontal tokens={{ childrenGap: 8 }}>
                    <PrimaryButton
                        text={duplicateSubmitting ? 'Duplicating...' : 'Duplicate'}
                        onClick={onDuplicate}
                        disabled={duplicateSubmitting || duplicateTargetServiceId === undefined}
                    />
                    <DefaultButton text="Cancel" onClick={onDismiss} disabled={duplicateSubmitting} />
                </Stack>
            </Stack>
        </Panel>
    );
}
